import { useState } from 'react';
import { useTransition } from 'transition-hook';

import { Icon, Text, Content, Block } from './tooltip.styled';

// export type TooltipProps = {
//   info: any;
//   children: any;
// };

// standard
export const Tooltip = (props) => {
  const { info, children = '?', asIcon = true, top = '60px', width = '360px' } = props;
  const [show, setShow] = useState(false);
  const { stage, shouldMount } = useTransition(show, 150);
  // console.log('🚀 ~ Tooltip ~ stage:', stage, shouldMount);

  const initShow = () => {
    setShow(true);
  };

  const initHide = () => {
    setShow(false);
  };

  return (
    <Content>
      {asIcon ? (
        <Icon onMouseEnter={initShow} onMouseLeave={initHide}>
          {children}
        </Icon>
      ) : (
        <Text onMouseEnter={initShow} onMouseLeave={initHide}>
          {children}
        </Text>
      )}

      {shouldMount && (
        <Block className={stage} style={{ top, width }}>
          {info}
        </Block>
      )}
    </Content>
  );
};
